import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { UserType } from '../auth/auth.service';
import { log } from 'console';
import { User } from '../../interfaces/users/user';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  constructor() {}

  // Decode JWT token to get its payload
  decodeToken(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decodePayload = atob(payload);
      return JSON.parse(decodePayload);
    } catch (error) {
      console.error('Error decoding token', error);
      return null;
    }
  }

  // Save data to local storage
  saveTokenData(token: string, refreshToken: string): void {
    const tokenData = this.decodeToken(token);
    if (tokenData) {
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('tokenExpiration', tokenData.exp.toString());
      localStorage.setItem('userId', tokenData.Profile.Id);
      localStorage.setItem('userEmail', tokenData.email);
      localStorage.setItem('profiles', tokenData.Profile);
      localStorage.setItem('userProfile', tokenData.Profile);
      localStorage.setItem('userRole', tokenData.Roles);
      localStorage.setItem('userPermissions', tokenData.Permissions);
      localStorage.setItem('hasAdmin', tokenData.hasadmin);
    }
  }

  saveToken(token: string): void {
    const tokenData = this.decodeToken(token);
    if (tokenData) {
      localStorage.setItem('token', token);
      localStorage.setItem('tokenExpiration', tokenData.exp.toString());
      localStorage.setItem('userId', tokenData.Profile.Id);
      localStorage.setItem('userEmail', tokenData.email);
      localStorage.setItem('profiles', tokenData.Profile);
      localStorage.setItem('userProfile', tokenData.Profile);
      localStorage.setItem('userRole', tokenData.Roles);
      localStorage.setItem('userPermissions', tokenData.Permissions);
      localStorage.setItem('hasAdmin', tokenData.hasadmin);
    }
  }

  // Remove all tokens
  removeAuth(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('profiles');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('hasAdmin');
  }

  // Get token from local storage
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  // Get refresh token from local storage
  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  // Get profile from local storage
  getProfile(): User | null {
    const profileJson = localStorage.getItem('profiles');
    if (profileJson) {
      return JSON.parse(profileJson) as User;
    }
    return null;
  }

  // Get user permissions from local storage
  getUserPermissions() {
    const permissionsJson = localStorage.getItem('userPermissions');
    if (permissionsJson) {
      return JSON.parse(permissionsJson);
    }
    return null;
  }

  // Get user role from local storage
  getUserRole(): any {
    return JSON.parse(localStorage.getItem('userRole')!);
  }

  get authUserProfile() {
    return this.getLocalStorageItem('userProfile');
  }

  getLocalStorageItem(key: string): any {
    return JSON.parse(localStorage.getItem(key));
  }

  // get admin status
  getHasAdmin(): any {
    return JSON.parse(localStorage.getItem('hasAdmin')!);
  }

  // remove token
  removeToken(): void {
    localStorage.removeItem('token');
  }

  removeRefreshToken(): void {
    localStorage.removeItem('refreshToken');
  }

  removeProfile(): void {
    localStorage.removeItem('profiles');
  }
}
